import React, { Fragment } from "react";
import { Dimmer, Loader, Segment } from "semantic-ui-react";
import logo from "./callable-final-design-04.png";

type SimpleLoaderProps = {
  loading: boolean;
  children: any;
};

const SimpleLoader = ({ loading, children }: SimpleLoaderProps) => {
  return (
    <Segment>
      <Dimmer active={loading} page inverted>
        <Loader
          as={() => (
            <Fragment>
              <img id='callable-spinner' src={logo} alt='callable-logo' />
              <h5 style={{ color: "#CCC" }}>LOADING..</h5>
            </Fragment>
          )}
        ></Loader>
      </Dimmer>
      {children}
    </Segment>
  );
};

export default SimpleLoader;
